"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItemIcon = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["className"];

var ListItemIcon = function ListItemIcon(props) {
  var className = props.className,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_ListItemIcon.default, (0, _extends2.default)({}, otherProps, {
    className: (0, _classnames.default)("prmbl-listItemIcon", className)
  }));
}; // TODO: Deprecate this


exports.ListItemIcon = ListItemIcon;
var _default = ListItemIcon;
exports.default = _default;